module.exports = __webpack_public_path__ + "img/icon_shsb.8e10dbdf.png";